module.exports = __webpack_public_path__ + "static/img/FullBodyXRAY2.5050c313.jpg";